export default __webpack_public_path__ + "static/media/starIcon.03a6be1a.svg";